import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const rateZonesAdapter = getAdapter();

const rateZonesSlice = createSlice({
  name: 'rateZones',
  initialState: rateZonesAdapter.getInitialState(),
  reducers: {
    setRateZones: (state, { payload: { rateZones } }) => {
      rateZonesAdapter.setAll(state, rateZones);
    },
  },
});

const selectors = rateZonesAdapter.getSelectors(({ rateZones }) => rateZones);

export const getRateZonesIncludingDeleted = (state) => selectors.selectAll(state);

export const getRateZones = (state) => getRateZonesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setRateZones,
} = rateZonesSlice.actions;

export default rateZonesSlice.reducer;
